module.exports = __webpack_public_path__ + "static/media/compensar1.464f9654.svg";